import { icons } from 'lucide-react';

/**
 * SlideIcon - Dynamic Lucide icon renderer
 * Accepts an icon name string and renders the corresponding SVG.
 *
 * @param {string} name - Lucide icon name (e.g. "ShieldCheck", "Bot")
 * @param {number} size - Icon size in px (default 48)
 * @param {number} strokeWidth - Stroke width (default 1.5)
 * @param {string} className - Optional CSS class
 */
const SlideIcon = ({ name, size = 48, strokeWidth = 1.5, className }) => {
  const Icon = icons[name];

  if (!Icon) {
    return null;
  }

  return <Icon size={size} strokeWidth={strokeWidth} className={className} />;
};

export default SlideIcon;
